module.exports = __webpack_public_path__ + "static/media/meeting-employer.7e8a161f.jpg";